export const ADD_FILE = 'ADD_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';
export const CHANGE_FILE_SELECTION = 'CHANGE_FILE_SELECTION';

export const initialState = (props = {}) => {
  const { files = [], selectedFileIndex = null } = props;

  return {
    files,
    size: files.length,
    selectedFileIndex
  };
};

function fileReducer(state, action) {
  switch (action.type) {
    case ADD_FILE: {
      const { files, multiple } = action;
      const updatedFiles = multiple ? [].concat(state.files, files) : files;
      const nextState = {
        ...state,
        files: updatedFiles,
        size: updatedFiles.length
      };

      if (action.callback) {
        action.callback(nextState);
      }

      return nextState;
    }
    case REMOVE_FILE: {
      const { fileToBeRemoved, callback } = action;
      const updatedFiles = state.files.filter(file => file !== fileToBeRemoved);
      const deletedFileIndex = state.files.findIndex(
        file => file === action.fileToBeRemoved
      );

      const nextState = {
        ...state,
        files: updatedFiles,
        size: updatedFiles.length
      };

      if (state.selectedFileIndex === deletedFileIndex) {
        nextState.selectedFileIndex = null;
      }

      if (callback) {
        callback(nextState);
      }

      return nextState;
    }
    case CHANGE_FILE_SELECTION: {
      const { callback, selectedFileIndex } = action;
      const nextState = {
        ...state,
        selectedFileIndex
      };

      if (callback) {
        callback(nextState);
      }

      return nextState;
    }
    default:
      throw new Error('Not valid action');
  }
}

export default fileReducer;
